"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EWizardCustomerType = void 0;
let EWizardCustomerType = exports.EWizardCustomerType = /*#__PURE__*/function (EWizardCustomerType) {
  EWizardCustomerType["All"] = "All";
  EWizardCustomerType["OnlyForMe"] = "OnlyForMe";
  EWizardCustomerType["OnlyForOtherCustomers"] = "OnlyForOtherCustomers";
  return EWizardCustomerType;
}({});
